import React from 'react';
import {
  Button,
  IconReset,
  IconSearch,
  IconShield,
  IconTrash,
  Modal,
  Skeleton,
} from 'gatorcomponents';
import BrandByMonarx from '@/components/GatorProtect/BrandByMonarx/BrandByMonarx';
import useLocale from '@/hooks/useLocale';
import { useResize } from '@/hooks/useResize';
import * as Styles from './GatorProtectNoThreatsModal.styles';

const MOBILE_BREAKPOINT = 425;

const FEATURE_ICONS = [
  <IconSearch key="feature-search" size="md" color="primaryExtraDark" />,
  <IconTrash key="feature-trash" size="md" color="primaryExtraDark" />,
  <IconReset key="feature-reset" size="md" color="primaryExtraDark" />,
];

const GatorProtectNoThreatsModal = ({
  onClose,
  onPrimary,
  pricingFootnoteDisplayValue,
  isPricingFootnoteLoading = false,
}) => {
  const { width } = useResize();
  const isMobile = width <= MOBILE_BREAKPOINT;
  const { gatorProtect: gatorProtectLocale } = useLocale();

  if (!gatorProtectLocale?.noThreatsModal) {
    return null;
  }

  const { noThreatsModal: locale } = gatorProtectLocale;

  return (
    <Modal
      onClose={onClose}
      maxWidth={isMobile ? '100%' : 800}
      maxHeight={isMobile ? '621' : '656'}
      mobileMaxHeight="fit-content"
      noHeader
      testId="gator-protect-no-threats-modal"
    >
      <Styles.Root $isMobile={isMobile} data-testid="gator-protect-no-threats-modal__content">
        <Styles.BrandByMonarxWrapper $isMobile={isMobile}>
          <BrandByMonarx
            isMobile={isMobile}
            shieldVariant="blue"
            variant="light"
          />
        </Styles.BrandByMonarxWrapper>

        <Styles.Headline $isMobile={isMobile}>
          <strong>{locale.headlineLead}</strong>
          {locale.headlineRest}
        </Styles.Headline>

        <Styles.FeaturesBlock $isMobile={isMobile}>
          {locale.features.map((feature, index) => (
            <Styles.FeatureRow key={feature.title}>
              <Styles.FeatureIconWrap>
                {FEATURE_ICONS[index]}
              </Styles.FeatureIconWrap>
              <Styles.FeatureTexts>
                <Styles.FeatureTitle $isMobile={isMobile}>{feature.title}</Styles.FeatureTitle>
                <Styles.FeatureDescription>{feature.description}</Styles.FeatureDescription>
              </Styles.FeatureTexts>
            </Styles.FeatureRow>
          ))}
        </Styles.FeaturesBlock>

        <Styles.PrimaryButtonWrap $isMobile={isMobile}>
          <Button
            width="full"
            label={locale.primaryCta}
            onClick={onPrimary}
            size="large"
            variant="primary"
            notFillSVG
            iconLeft={<IconShield size="md" color="highPure" />}
          />
          {isPricingFootnoteLoading ? (
            <Styles.PricingFootnoteSkeleton data-testid="gator-protect-no-threats-modal-pricing-skeleton">
              <Skeleton variant="textLine" width="100%" height="14px" />
            </Styles.PricingFootnoteSkeleton>
          ) : (
            <Styles.PricingFootnote>
              {locale.pricingFootnote({ price: pricingFootnoteDisplayValue })}
            </Styles.PricingFootnote>
          )}
        </Styles.PrimaryButtonWrap>
      </Styles.Root>
    </Modal>
  );
};

export default GatorProtectNoThreatsModal;
